import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_emojis",
  "use": "webinar_card_icon_emojis-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_emojis\"><path d=\"M10 1.667c-4.609 0-8.334 3.75-8.334 8.333a8.333 8.333 0 1 0 8.333-8.334Zm2.916 5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-5.833 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm2.916 7.916a4.554 4.554 0 0 1-3.516-1.659c-.45-.542.02-1.258.724-1.258h5.578c.706 0 1.175.719.724 1.262a4.548 4.548 0 0 1-3.51 1.655Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol